<a   class="skip-link" data-translate="text">SkipToMain</a>

<soho-icons *ngIf="!useUpliftIcons"></soho-icons>
<soho-icons-uplift *ngIf="!useUpliftIcons"></soho-icons-uplift>
<soho-icons-empty *ngIf="!useUpliftIcons"></soho-icons-empty>
<soho-icons-empty-uplift *ngIf="!useUpliftIcons"></soho-icons-empty-uplift>
<soho-icons-new *ngIf="useUpliftIcons"></soho-icons-new>
<soho-icons-empty-new *ngIf="useUpliftIcons"></soho-icons-empty-new>

<app-masthead></app-masthead>

<nav soho-application-menu soho-busyindicator class="is-personalizable" [filterable]="true" [openOnLarge]="false"
  [dismissOnClickMobile]="true">
  <div soho-searchfield-wrapper>
    <label class="audible" for="application-menu-searchfield">Search</label>
    <input soho-searchfield id="application-menu-searchfield" [clearable]="true" />
  </div>
  <div class="accordion panel inverse" data-options="{'allowOnePane': true, rerouteOnLinkClick: false}">
        <div *ngIf="showMenu"><h2 style="color: white; padding: 10px;font-size: 20px;">Standard Plans</h2></div>
        <ng-container *ngFor="let item of FilteredMenuItems;let i = index">
          <div id="Menu_{{item.Key}}" class="accordion-header" >
            <a href="javascript:void(0);"><span>{{item.Key}}</span></a>
          </div>
          <div id="MenuPane_{{item.Key}}" class="accordion-pane">
            <ng-container *ngFor="let val of item.Value;let i = index">
              <div id="Item_{{val.AppName}}" style="border:0px;box-shadow: none" class="accordion-header list-item">
                <a [routerLink]="[val.AppName]"><span>{{val.MenuItem}}</span></a></div>
            </ng-container>
          </div>
        </ng-container>
        <div *ngIf="showMenu"><h2 style="color: white;padding: 10px;font-size: 20px;">Custom Plans</h2></div>
        <ng-container *ngFor="let item of FilteredMenuManualItems;let i = index">
          <div id="Menu_{{item.Key}}" class="accordion-header" >
            <a href="javascript:void(0);"><span>{{item.Key}}</span></a>
          </div>
          <div id="MenuPane_{{item.Key}}" class="accordion-pane">
            <ng-container *ngFor="let val of item.Value;let i = index">
              <div id="Item_{{val.AppName}}" style="border:0px;box-shadow: none" class="accordion-header list-item">
                <a [routerLink]="[val.AppName]"><span>{{val.MenuItem}}</span></a></div>
            </ng-container>
          </div>
        </ng-container>
        <div *ngIf="showMenu && accountManagementEnabled"><h2 style="color: white;padding: 10px;font-size: 20px;">Application Access</h2></div>
        <ng-container *ngFor="let item of AccessControllerItems;let i = index">
          <div id="Menu_{{item.Key}}" class="accordion-header" >
            <a href="javascript:void(0);"><span>{{item.Key}}</span></a>
          </div>
          <div id="MenuPane_{{item.Key}}" class="accordion-pane">
            <ng-container *ngFor="let val of item.Value;let i = index">
              <div id="Item_{{val.AppName}}" style="border:0px;box-shadow: none" class="accordion-header list-item">
                <a [routerLink]="[val.AppName]"><span>{{val.MenuItem}}</span></a></div>
            </ng-container>
          </div>
        </ng-container>
  </div>
</nav>
<div class="page-container no-scroll">
  <app-header1></app-header1>

  <div id="maincontent" class="page-container scrollable" role="main">
    <router-outlet></router-outlet>
  </div>
</div>
